import { render, staticRenderFns } from "./EndorsementTable.vue?vue&type=template&id=b7344e02&scoped=true&"
import script from "./EndorsementTable.vue?vue&type=script&lang=js&"
export * from "./EndorsementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7344e02",
  null
  
)

export default component.exports